import { NgClass } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

import { IconName } from '../icons/auto-generated/icon-name';
import { IconComponent } from '../icons/icon.component';

@Component({
  selector: 'mop-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  imports: [NgClass, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  size = input<'lg' | 'md' | 'sm'>('md');
  type = input<'danger' | 'primary' | 'secondary' | 'warning'>('primary');
  style = input<'outline' | 'solid' | 'text'>('solid');
  text = input('');
  disabled = input(false, { transform: booleanAttribute });
  loading = input(false, { transform: booleanAttribute });
  loadingText = input('');
  iconOnly = input(false, { transform: booleanAttribute });
  icon = input<'' | IconName>('');
  ariaLabel = input<string>('');
  buttonClicked = output();

  private readonly computedBtnSizeClasses = computed(() => ({
    'btn-lg': this.size() === 'lg',
    'btn-sm': this.size() === 'sm',
  }));
  private readonly computedBtnIconClasses = computed(() => ({
    'btn-icon-only': this.iconOnly(),
  }));
  private readonly computedBtnTypeAndStyleClasses = computed(() => {
    const styleClass = this.style() === 'solid' ? '' : `${this.style()}-`;

    const btnClass = `btn-${styleClass}${this.type()}`;

    return btnClass;
  });

  protected computedBtnClasses = computed(() =>
    [
      this.computedBtnTypeAndStyleClasses(),
      ...Object.entries(this.computedBtnSizeClasses())
        .filter(([, value]) => value)
        .map(([key]) => key),
      ...Object.entries(this.computedBtnIconClasses())
        .filter(([, value]) => value)
        .map(([key]) => key),
    ].join(' ')
  );
  protected computedDisabledState = computed(
    () => this.loading() || this.disabled()
  );
  protected computedIconSize = computed(() => {
    switch (this.size()) {
      case 'lg':
      case 'md':
        return 20;
      case 'sm':
        return 14;
      // no default
    }
  });

  protected computedText = computed(() =>
    this.loading() && this.loadingText() !== ''
      ? this.loadingText()
      : this.text()
  );
}
